import {
  InteractionRequiredAuthError,
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";

export const getAccessToken = async (
  instance: IPublicClientApplication,
  inProgress: InteractionStatus,
  scopes: string[]
): Promise<string | undefined> => {
  const account = instance.getActiveAccount();
  if (!account) {
    throw new Error("No active account found");
  }

  try {
    const response = await instance.acquireTokenSilent({
      scopes,
      account,
    });
    return response.accessToken;
  } catch (error: any) {
    const message = error?.message as string | undefined;
    const errorCode = error?.errorCode as string | undefined;

    if (
      error instanceof InteractionRequiredAuthError ||
      errorCode === "invalid_request" ||
      message?.includes("AADSTS90009")
    ) {
      if (inProgress === InteractionStatus.None) {
        const response = await instance.acquireTokenPopup({
          scopes,
          account,
        });
        return response.accessToken;
      }

      console.error(error);
      return;
    }

    console.error("Error acquiring token:", error);
  }
};
